// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XfX4t","colBig":"styles_colBig__XwYkp","colSmall":"styles_colSmall__2y2jU"};